import React, { useEffect, useState } from 'react'
import ChatMessage from './ChatMessage'

export default function UserMessages(props) {


    useEffect(() => {
        document.getElementById('messages-container').scrollTo({ top: document.getElementById('messages-container').scrollHeight, behavior: 'smooth' })
    }, [props.messages.length]);

    return (

        <div id="messages-container" className="flex flex-col flex-grow w-full gap-y-2 mb-20 overflow-y-auto">
            {props.messages.map(message =>
            (
                <ChatMessage data={message}
                />
            )
            )}
        </div>
    );
};